export default __webpack_public_path__ + "static/media/KOD0006-min.e04c0042.webp";